/**
 * The one place the progress colour bands live — every progress bar resolves its fill through here.
 * Boundaries are inclusive at the top, and colour depends on the percentage alone, never on status.
 */
export function progressBarColorClass(percentage: number | null | undefined): string {
  const value = clampProgressPercentage(percentage);

  if (value <= 30) return "bg-error-400";
  if (value <= 70) return "bg-warning-300";
  if (value <= 80) return "bg-success-300";
  return "bg-success-400";
}

/** The API supplies the 0-100 integer; anything missing or out of range reads as 0. */
export function clampProgressPercentage(percentage: number | null | undefined): number {
  if (!Number.isFinite(percentage)) return 0;
  return Math.min(100, Math.max(0, Math.round(percentage as number)));
}
